import { FEATURES_AGROGEST } from './environment.agrogest';

export const FEATURES_FITOSGEST = {
    ...FEATURES_AGROGEST,
    applicationType: 'fitosgest',

    hasClients: true,
    clienteName: 'Cliente',
    clientesName: 'Clientes'
}